import { UserSettings } from '../types';

import { headerPrivateModeScheme } from './headerPrivateMode';
import { selectedColumnsSettingScheme } from './selectedColumnsSetting';
import { languagesScheme } from './languages';
import { summaryFormPresetsScheme } from './summaryFormPresets';
import { columnsOrderSettingScheme } from './columnsOrderSetting';
import { dashboardScheme } from './dashboard';
import { dashboardCalculatorScheme } from './dashboardCalculator';
import { chartCollapsedScheme } from './chartCollapsed';
import { snowballEffectScheme } from './snowballEffect';
import { smartlinksSelectedColumnsSettingScheme } from './smartlinksSelectedColumnsSetting';

// eslint-disable-next-line import/prefer-default-export
export const VALIDATION_SCHEMAS = {
  [UserSettings.HeaderPrivateMode]: headerPrivateModeScheme,
  [UserSettings.SelectedColumnsSetting]: selectedColumnsSettingScheme,
  [UserSettings.SmartlinksSelectedColumnsSetting]:
    smartlinksSelectedColumnsSettingScheme,
  [UserSettings.Languages]: languagesScheme,
  [UserSettings.ColumnsOrderSetting]: columnsOrderSettingScheme,
  [UserSettings.SummaryFormPresets]: summaryFormPresetsScheme,
  [UserSettings.Dashboard]: dashboardScheme,
  [UserSettings.DashboardCalculator]: dashboardCalculatorScheme,
  [UserSettings.ChartCollapsed]: chartCollapsedScheme,
  [UserSettings.SnowballEffect]: snowballEffectScheme,
};
